import { generatedAPI } from '@grafana/api-clients/rtkq/dashboard/v0alpha1';

export const dashboardAPIv0alpha1 = generatedAPI.enhanceEndpoints({});

export const { useGetSearchQuery } = dashboardAPIv0alpha1;
